import StoreSettingImportForm from './StoreSettingImportForm';

export default StoreSettingImportForm;
